import { useContext } from "react"
import { TextsContext } from "../../../context/textsContext"
import { TitleH3Component } from "../../../components/TitleH3Component"

export const TextMessageLalted = () => {

    const { texts } = useContext(TextsContext)

    return (
        <TitleH3Component styleGroup={`Poppins fw_400 color_primary mb-0 p-1`}>
            <p>{texts?.step11_lalted_message_text}:</p>
            <p><span className="raleway_bold">{texts?.step11_lalted_message_brazil}</span>: {texts?.step11_lalted_message_brazil_text}</p>
            <p><span className="raleway_bold">{texts?.step11_lalted_message_mexico}</span>: {texts?.step11_lalted_message_mexico_text}</p>
            <p><span className="raleway_bold">{texts?.step11_lalted_message_central_america}</span>: {texts?.step11_lalted_message_central_america_text}</p>
            <p><span className="raleway_bold">{texts?.step11_lalted_message_chile}</span>: {texts?.step11_lalted_message_chile_text}</p>
        </TitleH3Component>
    )
}
